import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "licenceFilled"
const LicenceFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M21 3.75C21.828 3.75 22.5 4.422 22.5 5.25V18.75C22.5 19.578 21.828 20.25 21 20.25H3C2.172 20.25 1.5 19.578 1.5 18.75V5.25C1.5 4.422 2.172 3.75 3 3.75zM5.25 15.75C4.836 15.75 4.5 16.086 4.5 16.5S4.836 17.25 5.25 17.25H18.75C19.164 17.25 19.5 16.914 19.5 16.5S19.164 15.75 18.75 15.75zM5.25 6.75C4.836 6.75 4.5 7.086 4.5 7.5V12.75C4.5 13.164 4.836 13.5 5.25 13.5H10.5C10.914 13.5 11.25 13.164 11.25 12.75V7.5C11.25 7.086 10.914 6.75 10.5 6.75zM13.5 10.125C13.086 10.125 12.75 10.461 12.75 10.875S13.086 11.625 13.5 11.625H17.25C17.664 11.625 18 11.289 18 10.875S17.664 10.125 17.25 10.125zM13.5 7.5C13.086 7.5 12.75 7.836 12.75 8.25S13.086 9 13.5 9H18.75C19.164 9 19.5 8.664 19.5 8.25S19.164 7.5 18.75 7.5z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LicenceFilledIcon
